import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { designerPaths } from '../../designer.paths';
import { DsgTranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'ss-login-expired-dialog',
  standalone: true,
  imports: [
    CommonModule,
    DsgTranslatePipe,
    MatButtonModule,
    MatDialogModule
  ],
  host: {
    class: 'full-stretch flex-column padding-large flex--align-center'
  },
  templateUrl: './login-expired-dialog.component.html',
  styleUrls: ['./login-expired-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginExpiredDialogComponent {

  constructor(
    private readonly _router: Router
  ) { }

  navigateToLogin() {
    this._router.navigate([designerPaths.auth]);
  }
}
